import * as sb from "./supabase";

const pick = () => sb;

export const getDataSource = pick;

export const initDataSource = () => pick().init?.();

export const listMyProjects = () => pick().listProjects();
export const saveProject = (args: any) => pick().saveProject(args);
export const deleteProject = (id: string) => pick().deleteProject(id);
export const getProject = (id: string) => pick().getProject(id);

export const getDs = getDataSource;
export default getDataSource;

export { patchProjectKpis } from "./patchProjectKpis";
export { projectToDealStub } from "./projectToDealStub";
